import { render, staticRenderFns } from "./Participate.vue?vue&type=template&id=30957dbe&scoped=true"
import script from "./Participate.vue?vue&type=script&lang=js"
export * from "./Participate.vue?vue&type=script&lang=js"
import style0 from "./Participate.vue?vue&type=style&index=0&id=30957dbe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30957dbe",
  null
  
)

export default component.exports